import { Component, Input } from '@angular/core';
import { Terminal } from '../../../../../../@core/domain/interfaces/terminal.interface';
import { IdentificationSearchService } from '../../../../../../@shared/services/identifications-search.service';

@Component({
  selector: 'app-identification',
  templateUrl: './identification.component.html',
  styleUrls: ['./identification.component.scss'],
})
export class IdentificationComponent {
  searchResultDetail: any;
  searchResultType: any;

  showSearchElement = true;
  showSearchResultElement = false;

  @Input()
  action: any;

  @Input()
  terminal!: Terminal;

  constructor(private identificationsSearchService: IdentificationSearchService) {}

  onSelectIdentificationId($event: any) {
    if ($event && $event.identification && $event.type) {
      this.showSearchElement = false;
      this.showSearchResultElement = true;
      this.identificationsSearchService
        .searchIdentificationByType($event.identification.id, $event.type.id)
        .subscribe((result: any) => {
          this.searchResultType = $event.type.id;
          this.searchResultDetail = result;
        });
    }
  }

  onDoResetSearch($event: any) {
    this.showSearchElement = true;
    this.showSearchResultElement = false;
  }

  onSearchCompleted() {}
}
